import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-client-contact',
  templateUrl: './edit-client-contact.component.html',
  styleUrls: ['./edit-client-contact.component.css']
})
export class EditClientContactComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
